import React, { useState, useEffect } from "react";
import { Row, Col } from "antd";
import { useLibraryCreativesContext } from "../../../../core/components/creatives/library/useLibraryCreativesContext";
import "./../library/creativestyle.css";
import AdPreviewCard from "../components/AdGroupPreviewCard";
import AdGroupDetailsCard from "../components/AdGroupDetailsCard";
import AdGroupVideosCard from "../components/AdGroupVideosCard";
import PageHeaderLayoutComponent from "../components/HeaderGroup";

// NEW IMPORTS - Enhanced navigation system

const VideoGroupDetail = () => {
  const {
    adgroupinfo,
    refetchAdGroupInfo,
    orgVideoMedias,
  } = useLibraryCreativesContext();
  const [mediaKeys, setMediaKeys] = useState([]);

  useEffect(() => {
    if (
      adgroupinfo &&
      adgroupinfo.adGroupCreatives &&
      adgroupinfo.adGroupCreatives.medias
    ) {
      const keys = adgroupinfo.adGroupCreatives.medias.map(media => media.key);
      setMediaKeys(keys);
    }
  }, [adgroupinfo]);

  // Get ad group name for breadcrumb
  const adGroupName = adgroupinfo && adgroupinfo.adGroupCreatives 
    ? adgroupinfo.adGroupCreatives.name 
    : "Loading...";
  const adGroupId = adgroupinfo && adgroupinfo.adGroupCreatives 
    ? adgroupinfo.adGroupCreatives.id 
    : null;

  return (
    <>

      <PageHeaderLayoutComponent adgroupinfo={adgroupinfo} mediaType="VIDEO" />
      <Row gutter={[16, 16]} className="crow-whole-page">
        <Col xs={24} sm={24} md={24} lg={10}>
          <AdPreviewCard mediaKeys={mediaKeys} />
        </Col>
        <Col xs={24} sm={24} md={24} lg={14}>
          <AdGroupDetailsCard adgroupinfo={adgroupinfo} mediaType="VIDEO" />
        </Col>
        <Col span={24} className="ccol-ad-groups">
          <AdGroupVideosCard
            adgroupinfo={adgroupinfo}
            refetchAdGroupInfo={refetchAdGroupInfo}
            orgMedias={orgVideoMedias ? orgVideoMedias.medias : []}
            adGroupId={
              adgroupinfo && adgroupinfo.adGroupCreatives
                ? adgroupinfo.adGroupCreatives.id
                : ""
            }
          />
        </Col>
      </Row>
    </>
  );
};

export default VideoGroupDetail;